import React from 'react';

const UnoHome = () => {
  return (
    <section id="nosotros" className="dt-uno dt-section">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Columna de imágenes (mismas dos imágenes) */}
          <div className="col-lg-6">
            <div className="dt-uno__media">
              <figure className="dt-uno__img wow fadeInUp" data-wow-delay="200ms">
                <img src="/assets/img/productos/pisos-spc-premium/spc-premium-install.jpeg" alt="Piso SPC Premium instalado" />
              </figure>
              <figure className="dt-uno__img dt-uno__img--b wow fadeInUp" data-wow-delay="300ms">
                <img src="/assets/img/home/index-contenedor.jpg" alt="Contenedor con producto en stock de bodega" />
              </figure>
              <div className="dt-uno__badge">
                <strong>+20</strong>
                <span>años en el mercado</span>
              </div>
            </div>
          </div>

          {/* Columna de texto (mismo copy) */}
          <div className="col-lg-6 wow fadeIn" data-wow-delay="400ms">
            <span className="dt-eyebrow">Sobre Decototal</span>
            <h2 className="h1 mb-4">En Decototal somos una comercializadora con más de 20 años en el mercado.</h2>
            <p className="lead dt-uno__lead mb-0">
              Nos especializamos en la distribución de productos de alta calidad, incluyendo recubrimientos para pisos y muros que son sustentables y libres de mantenimiento.
            </p>

            <ul className="dt-uno__chips">
              <li><i className="fas fa-leaf" aria-hidden="true"></i> Sustentables</li>
              <li><i className="fas fa-check-circle" aria-hidden="true"></i> Libres de mantenimiento</li>
              <li><i className="fas fa-truck" aria-hidden="true"></i> Entrega inmediata</li>
            </ul>

            <div className="dt-uno__actions">
              <a className="butn-style3" href="/contacto-decototal">¡Cotiza Ahora!</a>
              <a className="dt-link" href="#pisos">
                Ver productos <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </a>

              {/* Botón de WhatsApp oculto (descomentar para restaurar)
              <ul className="social-icon-style3 mb-0 list-unstyled">
                <li>
                  <a href="https://wa.me/525620863653?text=Hola,%2C%20quisiera%20más%20información%20de%20sus%20productos." target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </li>
              </ul>
              */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnoHome;